/**
 * Luvè: "Make it the Corner Trio" in the cart (snippets/luve-cart-upsell.liquid). Adds the missing heights through
 * Horizon's batch add, as the Corner Trio does, so the cart drawer and the cart page update in place.
 */
import { CartErrorEvent, CartLinesUpdateEvent } from '@shopify/events';

class LuveCartUpsell extends HTMLElement {
  #busy = false;

  connectedCallback() {
    this.querySelector('[data-upsell-add]')?.addEventListener('click', this.#add);
  }

  disconnectedCallback() {
    this.querySelector('[data-upsell-add]')?.removeEventListener('click', this.#add);
  }

  #add = () => {
    if (this.#busy) return;
    const ids = (this.dataset.ids || '').split(',').map(Number).filter(Boolean);
    if (!ids.length) return;
    this.#busy = true;
    const button = /** @type {HTMLButtonElement | null} */ (this.querySelector('[data-upsell-add]'));
    if (button) button.disabled = true;

    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((element) => (element instanceof HTMLElement ? element.dataset.sectionId : ''))
      .filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart',
        lines: ids.map((id) => ({ merchandiseId: String(id), quantity: 1 })),
        promise: deferred.promise,
      })
    );

    fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })), sections: sectionIds.join(',') }),
    })
      .then((response) => response.json())
      .then(async (response) => {
        const cart = await fetch(`${Theme.routes.cart_url}.json`, { headers: { Accept: 'application/json' } }).then((r) =>
          r.json()
        );
        const detail = { source: 'luve-cart-upsell', itemCount: ids.length, items: cart.items };
        if (response.status) {
          this.dispatchEvent(new CartErrorEvent({ error: response.message || 'Add to cart failed', code: 'INVALID' }));
          deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { ...detail, didError: true } });
          this.#status(response.description || 'Those trees could not be added.');
          if (button) button.disabled = false;
          return;
        }
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { ...detail, sections: response.sections, didError: false },
        });
      })
      .catch((error) => {
        console.error(error);
        deferred.reject(error);
        this.#status('Something went wrong. Please try again.');
        if (button) button.disabled = false;
      })
      .finally(() => {
        this.#busy = false;
      });
  };

  /** @param {string} text */
  #status(text) {
    const status = this.querySelector('[data-upsell-status]');
    if (status) status.textContent = text;
  }
}

if (!customElements.get('luve-cart-upsell')) customElements.define('luve-cart-upsell', LuveCartUpsell);
